module.exports = __webpack_public_path__ + "MuseoSans-500.55c124a36beb4cc1a429.eot";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/assets/fonts/MuseoSans-500.eot
// module id = ../../../../../src/assets/fonts/MuseoSans-500.eot
// module chunks = styles